<div id="{{ id_dialog }}"
     class="ui modal tiny"
     style="background-color: transparent; text-shadow: 0 0 10px rgb(0 255 255 / 95%);color: white;max-width:100%;pointer-events: none;" [style.width]="genislik">

    <div style="display: flex;align-items: center;justify-content: space-between; min-width: 150px;">
        <span style="pointer-events: all;text-align: center;margin-bottom: 0.2rem;background: linear-gradient(11deg, #000000b4, transparent),linear-gradient(11deg, transparent, #b3b3b3);padding: 2px 10px;border-radius: 50vh;font-weight: bolder;color: white;text-shadow: 0 0 10px rgb(0 255 255 / 95%);pointer-events: all;font-size: 0.65em;flex: 1;"
              class="baslikMove">
            <img [src]="aktifElement?.userData?.FikoArayuz?.simge"
                 style="width: 14px !important;height: 14px;object-fit: contain;">
            {{aktifElement?.name ?? "FikoYT Obje" }}

        </span>
        <!-- Kapatma Düğmesi
        <button
            (click)="kapa()"
            style="pointer-events: all; padding: 2px 6px; background-color: rgba(255, 0, 0, 0.6); color: white; border: 1px solid rgba(255, 0, 0, 0.8); border-radius: 3px; cursor: pointer; font-size: 0.8em; margin-left: 5px;"
            title="Menüyü Kapat">
            ✕
        </button> -->
    </div>
    <!--  -->
    <!-- <div class="scrolling content"
        style="border-radius: 50vh;background-color: rgba(0, 127, 127, 0.7);border: 1px solid rgba(127,255,255,0.25);padding: 5px;box-shadow: 0px 0px 12px rgb(0 255 255 / 50%);font-size:0.75em;">
        FikoYT Hızlı Menü
    </div> -->
    @if ((aktifElement?.hizli3DMenu ?? []).length > 0) {
    <div style="display: flex;align-items: center;justify-content: center;">
        <div style="display: flex;align-items: center;justify-content: center;width:min-content;">

            <span class="tepeAracCubugu"
                  style="pointer-events: all;">
                <span [ngSwitch]="item.tipi"
                      *ngFor="let item of aktifElement?.hizli3DMenu ?? []; trackBy: trackByMenuBaslik"
                      style="display: flex; align-items: center;">

                    <span *ngSwitchCase="'Ayraç'">
                        <span style="border-left: 1px solid white;"></span>
                    </span>

                    <button *ngSwitchDefault
                            class="circular ui icon {{ item.renkSinif ?? 'green' }} tiny button"
                            style="padding: 0 !important;"
                            [title]="item.baslik"
                            (click)="item.tiklandi ? item.tiklandi():null;">
                        @if (item.simge) {
                        <i class="icon {{ item.simge }}"
                           style="height: 22px;width: 22px;line-height: 22px;"></i>
                        }
                        @if (item.simgeYazi) {
                        <i class="icon"
                           style="height: 22px;width: 22px;line-height: 22px;">{{item.simgeYazi}}</i>
                        }
                        @if (item.resim) {
                        <img [src]="item.resim"
                             *ngIf="item.resim"
                             style="width: 22px !important; height: 22px; object-fit: contain;">
                        }
                    </button>

                </span>
            </span>

        </div>
    </div>
    }

    @if (aktifElement?.hizliMenu3DBilgi) {
    <div class="mt-1"
         style="
         position: relative;
         display: flex;
         color:white;
        font-size:0.75rem;
        background-color: rgba(0, 127, 127, 0.7);
        border-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        border-bottom-left-radius: 0.5em;
        border: 1px solid rgba(127, 255, 255, 0.25);
        padding: 1px 5px;
        box-shadow: 0px 0px 12px rgb(0 255 255 / 50%);
        pointer-events:all;
        max-height: 2.5rem;
        overflow: hidden;
        overflow-y: auto;
        ">
        {{aktifElement?.hizliMenu3DBilgi}}
    </div>
    }

    @defer (when aktifElement?.hizliMenu3DEk;on timer(500)) {
    <div class="mt-1"
         style="display: flex;align-items: center;justify-content: center;">
        <ng-container *ngComponentOutlet="aktifElement?.hizliMenu3DEk;inputs:aktifElement?.hizliMenu3DEkParametreler" />
    </div>
    }
</div>